module.exports = __webpack_public_path__ + "img/portada_arriba_der.c5902e27.png";